export const SidebarWidth = '360px';
export const ScrollbarWidth = '12px';
export const SearchBarLarge = '520px';
export const SearchBarSmall = '450px';
export const SearchBarInputMin = '100px';
